import VehicleBlockComponent from "./VehicleBlockComponent";

export default VehicleBlockComponent;
export { VehicleBlockComponent };
